import React from 'react';
import { useTranslation } from '../../../i18n/use-translation';
import { Image } from '../../atoms/image';
import { Wrapper } from '../../atoms/wrapper';
import { Section } from '../../enums/container'
import * as styles from './platform_section.module.sass';

export const PlatformSection = (props: any) => { 
const { locale } = useTranslation()

  return (
    <Wrapper section={Section.PLATFORM} cardClassName={styles.platform_section}>
      <h2 title={props.title} className={styles.mobile_heading} />

      <div className={styles.platform_description}>
        <h2 className={styles.laptop_heading}>{props.title}</h2>
        <div className={styles.benefits}>
          <div className={styles.benefits_part}>
            {props.benefits_description.map((item: any, key: any) => (
              <p key={key} className={styles.benefits_description}>
                {item.text}
              </p>
            ))}
          </div>
        </div>
        <div className={styles.button_container}>
          <a href={`https://apps.apple.com/ua/app/moniheal/id1503514770?l=${locale}`}>
            <Image
              srcs={[{ src: `/public-assets/img/badges/app_store/${locale}.png`, type: 'image/png' }]}
              src={`/public-assets/img/badges/app_store/${locale}.png`}
              alt={props.title}
              className={styles.badges}
            />
          </a>
          <a href={`https://play.google.com/store/apps/details?id=com.moniHeal&hl=${locale}`}>
            <Image
              srcs={[{ src: `/public-assets/img/badges/google_play/${locale}.png`, type: 'image/png' }]}
              src={`/public-assets/img/badges/google_play/${locale}.png`}
              alt={props.title}
              className={styles.badges}
            />
          </a>
        </div>
      </div>

      <Image srcs={props.srcPlatformMocap} src={props.src} alt={props.title} className={styles.mocap_img} />
    </Wrapper>
  );
};
